import { Meal } from "@/clients/models/Meal";
import { AutoScaleImage } from "@/components/image/auto-scale-image";
import { memo } from "react";

interface SelectedMealListProps {
  meals: Meal[];
}

export const SelectedMealList = memo(function SelectedMealList({
  meals,
}: SelectedMealListProps) {
  return (
    <div className="w-full flex flex-col gap-2">
      {meals.map((meal) => (
        <div
          key={meal.id}
          className="w-full flex items-center border rounded-xl border-gray-100"
        >
          <AutoScaleImage
            imageUri={meal.imageUri}
            alt={meal.name}
            hasOverlay={false}
            classNames={{
              container: "w-30 h-30 rounded-l-xl overflow-hidden",
              image: "w-30 h-30",
            }}
          />
          <div className="flex-1 flex flex-col text-sm! justify-around font-medium! gap-2 ml-4">
            <span className="text-base font-medium">{meal.name}</span>
            <span className="text-sm text-gray-500">{meal.brandName}</span>
          </div>
        </div>
      ))}
    </div>
  );
});
